const CATEGORY = 'Empreinte player';
let localEvent = [];
let isGlobale = false;
let Stop = false;

export async function gaEvent(event) {
  if(typeof  gtag === 'function' )
    gtag("event",event.action ,{event_category:CATEGORY,event_label:event.label,event_action:event.action ,non_interaction: true })
}

export async function gtagGlobal(player,sources, type) {
  let eventAction = [ {action:'play',label:'Play'},{action:'pause' , label:'Pause' }, {action:'ended',label:'Complete'} ,{action:'tracking:seek',label:'Seek'} ];
  if(type==='Stop') {
    Stop=true
  }
  if(type==='Global') {
    isGlobale= true
    if (localEvent.length > 0) {
      localEvent.map(event => {
        console.log("send event from local Event  ")
        gaEvent(event)
      })
    }
  }

  player.tech_.hls_.on('hlsFragBuffered',function(){
    let event={label:sources.src,action:"Buffer"}
    if(type==='Local' && !isGlobale  && !Stop) {
      localEvent.push(event)
    }else if(type==='Global'){
      gaEvent(event);
    }
  })


  eventAction.map(action=>{
    player.on(action.action, function() {
      let event={label:sources.src,action:action.label}
      if(type==='Local' && !isGlobale  && !Stop) {
        localEvent.push(event)
      }else if(type==='Global'){
        gaEvent(event);
      }
    });
  })
}



// WEBPACK FOOTER //
// ./src/GoogleAnalytics/gtpro.js